// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N7rOv","label":"styles_label__2hcud"};